var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-4 main-container sm:px-6"},[_c('div',{staticClass:"h-full"},[_c('div',{staticClass:"mt-5 scrollable"},[_c('files',{attrs:{"patient_id":_vm.patient.id}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }